<template>
  <el-form class="sentence-form" ref="form" label-width="100px">
    <div style="margin-left:100px;">
      <PinyinPreview class="pinyin-preview" :text="text" :pinyin="pinyin"></PinyinPreview>
    </div>
    <el-form-item label="拼音" style="margin-bottom:12px;" @change.native.capture="handleDialogText('text', 'pinyin')">
      <PinyinInput v-model="pinyin" :text="text" type="textarea" :autosize="{minRows:1}" resize="none"></PinyinInput>
    </el-form-item>
    <el-form-item label="句子" style="margin-bottom:12px;" @change.native.capture="handleDialogText('text', 'pinyin')">
      <el-input v-model="text" type="textarea" :autosize="{minRows:1}" resize="none"></el-input>
      <div style="color:#E6A23C;line-height:1.3;margin-top:3px;">注意：修改句子后请检查自动出题配置，如果有用到也需要一并修改</div>
    </el-form-item>
    <el-form-item label="音频" style="margin-bottom:12px;">
      <FileInput v-model="audio" accept="audio/*"></FileInput>
    </el-form-item>
    <el-form-item label="图片" style="margin-bottom:12px;">
      <FileInput v-model="image" accept="image/*"></FileInput>
    </el-form-item>
    <el-form-item label="驰声语音" style="margin-bottom:12px;">
      <el-input v-model="text_chivox" type="textarea" :autosize="{minRows:1}" resize="none"></el-input>
    </el-form-item>
    <PinyinPreview :text="text" :pinyin="text_chivox" pinyinglue="|" popover offsets></PinyinPreview>
    <el-collapse>
      <el-collapse-item name="自动出题配置">
        <template #title>
          <div class="text-center flex1">自动出题配置</div>
        </template>
        <BuildExerciseConfig v-model="data.exercise_config" :words="text"></BuildExerciseConfig>
      </el-collapse-item>
    </el-collapse>
  </el-form>
</template>

<script>
import dialog from '@/components/mixins/dialog.js'
import BuildExerciseConfig from "@/views/sentence/BuildExerciseConfig.vue";
import {getDataJson} from "./util.js";

export default {
  name: 'SentenceForm',
  components: {
    BuildExerciseConfig,
    PinyinPreview: require('@/components/PinyinPreview').default,
    PinyinInput: require('@/components/PinyinInput').default,
    FileInput: require('@/components/FileInput').default
  },
  mixins: [dialog],
  data() {
    return {
      id: null,
      text: '',
      pinyin: '',
      audio: '',
      image: '',
      text_chivox: '',
      data: {}
    }
  },
  methods: {
    initData(item) {
      this.id = item.id || null;
      this.text = item.text || ''
      this.pinyin = item.pinyin || ''
      this.audio = item.audio || ''
      this.image = item.image || ''
      this.text_chivox = item.text_chivox || ''
      this.data = item.data || (item.data_json ? JSON.parse(item.data_json) : {});
    },
    reset(model){
      this.initData(model);
    },
    getFormData() {
      return {
        id: this.id,
        text: this.text,
        pinyin: this.pinyin,
        image: this.image,
        audio: this.audio,
        text_chivox: this.text_chivox,
        data_json: getDataJson(this.data),
      }
    },
    submit() {
      var params = this.getFormData()
      if (params.id) {
        delete params.id
        return this.$http.put(this.$urls.sentence_update, params, {
          params: {id: this.id}
        })
      } else {
        return this.$http.post(this.$urls.sentence_create, params).then(data => {
          this.id = data.id
        })
      }
    }
  }
}
</script>
